// Themaknop: systeem, licht, donker. Onthouden in de cookie 3dm_thema (een jaar), zodat de
// server het thema al in <html data-theme> zet. ?thema=light|dark|auto in de URL dwingt het af.
// Gebundeld naar /js/core/thema.js; elke pagina laadt dit (core/html.ts).

type Thema = "auto" | "light" | "dark";
const volgorde: Thema[] = ["auto", "light", "dark"];
const namen: Record<Thema, string> = { auto: "systeem", light: "licht", dark: "donker" };

function huidig(): Thema {
  const q = /[?&]thema=(light|dark|auto)/.exec(location.search)?.[1] as Thema | undefined;
  if (q) return q;
  const t = document.documentElement.getAttribute("data-theme");
  return t === "light" || t === "dark" ? t : "auto";
}

function zet(t: Thema, knop: HTMLElement | null) {
  const root = document.documentElement;
  if (t === "auto") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", t);
  const veilig = location.protocol === "https:" ? "; Secure" : "";
  document.cookie =
    t === "auto" ? `3dm_thema=; Max-Age=0; Path=/; SameSite=Lax${veilig}` : `3dm_thema=${t}; Max-Age=31536000; Path=/; SameSite=Lax${veilig}`;
  if (knop) knop.textContent = `Thema: ${namen[t]}`;
}

const knop = document.getElementById("thema-knop");
let thema = huidig();
zet(thema, knop);
if (knop) {
  knop.hidden = false;
  knop.addEventListener("click", () => {
    thema = volgorde[(volgorde.indexOf(thema) + 1) % volgorde.length]!;
    zet(thema, knop);
  });
}
